<mat-card class="summary-card week">
	<div class="summary-title week">WEEK TO DATE</div>
	<div class="summary-content">
		<!-- Repeat for each metric -->
		<div class="summary-metric">
			<span class="metric-label">TOTAL SALES</span>
			<span class="metric-value">{{ totalSalesWeek | currency:'USD':'symbol':'1.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">TOTAL ORDERS / ITEMS</span>
			<span class="metric-value">{{ totalOrdersItemsWeek }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SALES VALUE / ITEM</span>
			<span class="metric-value">{{ salesValuePerItemWeek | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">AVERAGE ORDER $</span>
			<span class="metric-value">{{ averageOrderValueWeek | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI SALES</span>
			<span class="metric-value">{{ sushiSalesWeek | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">SUSHI ITEM SOLD</span>
			<span class="metric-value">{{ sushiItemsSoldWeek | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO SALES</span>
			<span class="metric-value">{{ bentoSalesWeek | currency:'USD':'symbol':'1.2-2' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">BENTO ITEM SOLD</span>
			<span class="metric-value">{{ bentoItemsSoldWeek | number:'0.0-0' }}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON SALES</span>
			<span class="metric-value">{{ commonSalesWeek | currency:'USD':'symbol':'1.2-2'}}</span>
		</div>
		<div class="summary-metric">
			<span class="metric-label">COMMON ITEM SOLD</span>
			<span class="metric-value">{{ commonItemsSoldWeek | number:'0.0-0'}}</span>
		</div>
	</div>
</mat-card>